/* 小喬（江東二喬） */
import { gd } from '../../core/kit.ts';
import { defineHero, hook } from '../define.ts';

export default defineHero({
  id: 'xiaoqiao', name: '小喬', sub: '江東二喬', faction: 'wu', role: '法師', weapon: 'fan',
  look: { female: true, head: 'bun', robe: true, size: 0.94, fx: '#ffcf8a', c: { cloth: '#e9a03a', sleeve: '#e9a03a', armor: '#fff4e0', flower: '#ff8aa8', fan: '#fff0d6' } },
  skills: [
    ['花扇', 'bolt', '扇出花風，造成 {80/130/180/230} 傷害。', { shape: 'wind' }],
    ['天香', 'hook', '用絲帶牽住敵人（附帶少量傷害），讓他朝小喬走過來 {1/1.25/1.5/1.75} 秒。', { el: 'wind' }],
    ['紅顏', 'passive', '附近（600 內）有男性隊友時，技能傷害 +5%；周瑜在附近時改為 +10%。', { pv: {}, sig: 'beauty' }],
    ['天香花陣', 'fire', '花瓣化為金光連爆四次，每次 {185/280/375} 傷害。', { pal: 'holy', el: 'wind' }],
  ],
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 紅顏：600 內有男性隊友技能傷害 +5%，周瑜在附近 +10%（每 0.5 秒刷新光環時重算）
    hook('aura', 20, function () {
      for (const u of this.units) {
        if (u.kind !== 'hero' || !u.spec.skills) continue;
        const i = u.spec.skills.findIndex((s) => s.sig === 'beauty');
        if (i < 0) continue;
        let b = 0;
        if (u.alive && u.skillLv[i]) for (const h of this.heroes(u.team)) {
          if (h === u || !h.alive || gd(u.x, u.y, h.x, h.y) > 600) continue;
          if (h.spec.id === 'zhouyu') { b = 10; break; }
          if (!h.spec.female) b = 5;
        }
        u.spAura = b;
      }
    }),
  ],
});
